import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ExpensesState } from "../dashboard/expenses/types";

interface DashboardSettings {
    mainMenuVisible: boolean
    refreshKey: number
}

interface ApplicationSettings {
    dashboard: DashboardSettings
}

const initialState: ApplicationSettings = {
    dashboard: {
        mainMenuVisible: true,
        refreshKey: Date.now()
    }
}

const applicationSettingsSlice = createSlice({
    name: 'applicationSettingsSlice',
    initialState,
    reducers: {
        toggleMainMenuVisibility(state: ApplicationSettings, action: PayloadAction<{ visible: boolean }>) {
            state.dashboard.mainMenuVisible = action.payload.visible
        },
        triggerRefresh(state: ApplicationSettings, action: PayloadAction) {
            state.dashboard.refreshKey = Date.now()
        }
    },
    extraReducers: (builder) => {

    },
})

export const actions = { ...applicationSettingsSlice.actions }
export default applicationSettingsSlice.reducer